<template>
  <button
    class="form-button"
    :disabled="disabled || isLoading"
    v-bind:class="{
      'has-icon-right': hasIconRight,
      'has-icon-left': hasIconLeft,
      'is-outlined': isOutlined,
      'is-link': isLink,
      'is-small': isSmall,
      'is-loading': isLoading,
    }"
  >
    <slot>Button</slot>
    <LoadingIcon class="form-button__loader" v-if="isLoading" />
  </button>
</template>

<script>
import LoadingIcon from '@/assets/images/loader.svg';

export default {
  name: 'FormButton',
  components: {
    LoadingIcon,
  },
  props: {
    disabled: Boolean,
    isLoading: Boolean,
    hasIconRight: Boolean,
    hasIconLeft: Boolean,
    isOutlined: Boolean,
    isLink: Boolean,
    isSmall: Boolean,
  },
};
</script>

<style lang="scss">
.form-button {
  align-items: center;
  align-self: center;
  background-color: $color-accent;
  border: 0;
  border-radius: $border-radius-large;
  color: $color-white;
  cursor: pointer;
  display: flex;
  font-size: 18px;
  min-height: 44px;
  outline: none;
  padding: 8px 24px;
  transition: background 200ms ease, box-shadow 200ms ease;

  &:hover,
  &:active {
    background-color: $color-accent-700;
  }

  &:focus {
    box-shadow: $shadow-focus-outline;
  }

  &:disabled {
    box-shadow: none;
    cursor: not-allowed;
    opacity: 0.5;
    background-color: $color-accent !important;
  }

  &.is-loading {
    // Cache l'icone s'il y en a un, peu importe le côté
    // Le loader est affiché dans le template en haut
    .feather {
      display: none;
    }
  }

  &__loader {
    flex: none;
    height: 20px;
    margin-left: 8px;
    width: 20px;
  }

  &.has-icon-right {
    padding-right: 16px;

    > .feather {
      flex: none;
      height: 20px;
      margin-left: 8px;
      width: 20px;
    }
  }

  &.has-icon-left {
    padding-left: 16px;

    > .feather {
      flex: none;
      height: 20px;
      margin-right: 8px;
      width: 20px;
    }
  }

  &.is-small {
    border-radius: $border-radius-large;
    font-size: 12px;
    min-height: 20px;
    padding: 4px 12px;
  }

  &.is-outlined {
    background-color: transparent;
    border: 1px solid $color-normal;
    color: $color-normal;

    &:hover {
      border-color: $color-accent;
    }

    &:disabled {
      background-color: transparent !important;
    }
  }

  &.is-link {
    background-color: transparent;
    border: none;
    border-radius: 0;
    color: $color-accent;
    font-size: 14px;
    min-height: auto;
    padding: 4px 0;
    position: relative;

    &::after {
      background: $color-accent-2;
      bottom: 2px;
      content: '';
      display: block;
      height: 1px;
      position: absolute;
      transition: bottom 0.2s ease-in-out;
      width: 100%;
    }

    &:hover {
      background-color: transparent;

      &::after {
        bottom: 0;
      }
    }

    &.is-small {
      font-size: 12px;
    }
  }
}
</style>
